import {Socket} from "./socket.js"
const SocketInit = {
  data() {
    return {
      //路径
      // equSocketUrl: "ws://192.168.2.251:8106/ws/equipment/",
      // repairSocketUrl: "ws://192.168.2.251:8106/ws/repair/",
      // maintainSocketUrl: "ws://192.168.2.251:8106/ws/maintain/",
      // inspectSocketUrl: "ws://192.168.2.251:8106/ws/inspect/",
      // weatherSocketUrl: "ws://192.168.2.251:8106/ws/weather/",
      // usersSocketUrl: "ws://192.168.2.251:8106/ws/users/",
      // statisticsSocketUrl: "ws://192.168.2.251:8106/ws/statistics/",
      // infoSocketUrl: "ws://192.168.2.251:8106/ws/info/",

      // 正式路径
      equSocketUrl: "wss://www.wx.gddx-v1.com/ws/equipment/",
      repairSocketUrl: "wss://www.wx.gddx-v1.com/ws/repair/",
      maintainSocketUrl: "wss://www.wx.gddx-v1.com/ws/maintain/",
      inspectSocketUrl: "wss://www.wx.gddx-v1.com/ws/inspect/",
      weatherSocketUrl: "wss://www.wx.gddx-v1.com/ws/weather/",
      usersSocketUrl: "wss://www.wx.gddx-v1.com/ws/users/",
      statisticsSocketUrl: "wss://www.wx.gddx-v1.com/ws/statistics/",
      infoSocketUrl: "wss://www.wx.gddx-v1.com/ws/info/",
      //socket实例
      equSocket: null,
      repairSocket: null,
      maintainSocket: null,
      inspectSocket: null,
      weatherSocket: null,
      usersSocket: null,
      statisticsSocket: null,
      infoSocket:null,
      isHospital:true, // 是否查医院排行

      // 折纸图参数
      lineSearchParam:{
        startTime: null, //开始时间
        endTime: null, //结束时间
        dateType:'month', // day / month
        hospitalId: null,//医院ID
      },
      //查询参数
      searchParam: {
        startTime: null, //开始时间
        endTime: null, //结束时间
        year: "", //查询年份(必要)
        hospitalId: null,//医院ID
        departId:null,// 科室ID
        // dateType:'day',
        findEquInspectPageParam:{//查询分页巡检工单
          page:1,
          size:10,
          hospitalId: null,
          // departId:null,
          createTimeBegin:null,
          createTimeEnd:null
        },
        findExecutingInspectPageParam:{//查询分页正在执行巡检数据
          page:1,
          size:10,
          hospitalId: null,
          departId:null,
          createTimeBegin:null,
          createTimeEnd:null
        },
        findInspectExecutingPageParam:{//查询分页正在巡检数据
          page:1,
          size:10,
          hospitalId: null,
          departId:null,
          createTimeBegin:null,
          createTimeEnd:null
        },
        findExecutingMaintainPageParam:{//分页查询正在执行保养数据
          page:1,
          size:10,
          hospitalId: null,
          departId:null,
          createTimeBegin:null,
          createTimeEnd:null
        },
        findMaintainExecutingPageParam:{//分页查询正在保养数据
          page:1,
          size:10,
          hospitalId: null,
          departId:null,
          createTimeBegin:null,
          createTimeEnd:null
          
        },
        findMaintainPageParam:{//查询分页保养单
          page:1,
          size:10,
          hospitalId: null,
          // departId:null,
          createTimeBegin:null,
          createTimeEnd:null
        },
        getEquPageParam:{//分页查询设备
          page:1,
          size:10,
          hospitalId: null,
          departId:null,
          measureType : null,
          warrantyStatus:null,
          typeId:null
        },
        pageRepairParam:{//维修设备分页
          page:1,
          size:10,
          hospitalId: null,
          departId:null,
          reportStartTime:null,
          reportEndTime:null,
          status:null, // 工单状态
        },
        pageBeingRepairedParam:{//正在维修设备分页
          page:1,
          size:10,
          hospitalId: null,
          departId:null,
          reportStartTime:null,
          reportEndTime:null
        },
        selectEngineerRankingByPage:{ 
          page:1,
          size:10,
          hospitalId: null,
          departId:null,
          startTime: null,
          endTime: null
        },
        limit: 10 ,//排行显示前几个
        limitRank: 40,//统计排行显示前几个
      }
    }
  },
  mounted() {

  },
  methods: {
    initSocket(id){
      //初始化当前年份
    var date = new Date();
    this.searchParam.year = date.getFullYear();
    //查询参数初始化(公共)
    let infoInitParam = {
      socketType: "updateParameter",
      hospitalManagementTypeSearchDTO : {
        hospitalId: this.searchParam.hospitalId,
        autoQrCode:false
      }
    }
    //查询参数初始化(用户)
    let userInitParam = {
      socketType: "updateParameter",
      userPageSearchDto : {
        hospitalId: this.searchParam.hospitalId
      }
    }

    //查询参数初始化(设备)
    let equInitParam = {
      socketType: "updateParameter",
      equMaintenanceTotalSearchDTO :{
        hospitalId: this.searchParam.hospitalId
      },
      equPurchaseTotalSearchDTO :{
        hospitalId: this.searchParam.hospitalId
      },
      equMedicalClassificationTotalSearchDTO :{
        hospitalId: this.searchParam.hospitalId
      },
      hospitalManageTotalSearchDTO :{
        hospitalId: this.searchParam.hospitalId
      }
    }

    //查询参数初始化(保养)
    let maintainInitParam = {
      socketType: "updateParameter",
      finishSearchDto: {
        createTimeBegin: this.searchParam.startTime,
        createTimeEnd: this.searchParam.endTime,
        hospitalId: this.searchParam.hospitalId
      },
      statisticsMaintainSearchDto: {
        searchTimeType: this.lineSearchParam.dateType,
        startTime:this.lineSearchParam.startTime,
        endTime:this.lineSearchParam.endTime,
        hospitalId: this.lineSearchParam.hospitalId
      }
    }

    //查询参数初始化(巡检)
    let inspectInitParam = {
      socketType: "updateParameter",
      finishSearchDto: {
        createTimeBegin: this.searchParam.startTime,
        createTimeEnd: this.searchParam.endTime,
        hospitalId: this.searchParam.hospitalId
      },
      statisticsInspectSearchDto: {
        searchTimeType: this.lineSearchParam.dateType,
        startTime:this.lineSearchParam.startTime,
        endTime:this.lineSearchParam.endTime,
        hospitalId: this.lineSearchParam.hospitalId
      }
    }

    //查询参数初始化(维修)
    let repairInitParam = {
      socketType: "updateParameter",
      largeScreenSearchDto: {
        startTime: this.searchParam.startTime,
        endTime: this.searchParam.endTime,
        hospitalId:this.searchParam.hospitalId,

      },
      isHospital: this.isHospital, //是否查医院排行
        statisticsParameterDto: {
          hospitalId:this.searchParam.hospitalId,
          startTime: this.searchParam.startTime,
        endTime: this.searchParam.endTime,
        }
    }

    //查询参数初始化(统计)
    let statisticsInitParam = {
      socketType: "updateParameter",
      largeScreenSearchDto: {
        startTime: this.searchParam.startTime,
        endTime: this.searchParam.endTime,
        hospitalId:this.searchParam.hospitalId,
      },
      finishSearchDto: {
        createTimeBegin: this.searchParam.startTime,
        createTimeEnd: this.searchParam.endTime,
        hospitalId: this.searchParam.hospitalId
      },
    }

    //初始化socket实例
    this.equSocket = new Socket(this.equSocketUrl, "equipment-"+id, this.acceptEquData,null,equInitParam);
    this.equSocket.createSocket();
    this.repairSocket = new Socket(this.repairSocketUrl, "repair-"+id, this.acceptRepairData,null, repairInitParam);
    this.repairSocket.createSocket();
    this.maintainSocket = new Socket(this.maintainSocketUrl, "maintain-"+id, this.acceptMaintainData,null, maintainInitParam);
    this.maintainSocket.createSocket();
    this.inspectSocket = new Socket(this.inspectSocketUrl, "inspect-"+id, this.acceptInspectData,null, inspectInitParam);
    this.inspectSocket.createSocket();
    this.weatherSocket = new Socket(this.weatherSocketUrl, "weather-"+id, this.acceptWeatherData);
    this.weatherSocket.createSocket();
    this.usersSocket = new Socket(this.usersSocketUrl, "users-"+id, this.acceptUsersData,null,userInitParam);
    this.usersSocket.createSocket();
    this.statisticsSocket = new Socket(this.statisticsSocketUrl, "statistics-"+id, this.acceptStatisticsData,this.acceptSharingData,statisticsInitParam);
    this.statisticsSocket.createSocket();
    this.infoSocket = new Socket(this.infoSocketUrl, "info-"+id, this.acceptInfoData,null,infoInitParam);
    this.infoSocket.createSocket();

    //3分钟更新一次天气(180000)
    setInterval(() => {
      this.weatherSocket.updateParameter()
    }, 180000)
    },
    // 管理类型
    getHospitalManagementTypeList(){
      let infoParam = {
        socketType: "updateParameter",
        hospitalManagementTypeSearchDTO : {
          hospitalId: this.searchParam.getEquPageParam.hospitalId,
          autoQrCode:false
        }
      }
      this.infoSocket.updateParameter(infoParam)
      console.log(infoParam)
    },
    //修改参数，重新查询数据
    changeParam() {
      //更新公共数据
      

      //更新用户数据
      let userParam = {
        socketType: "updateParameter",
        userPageSearchDto : {
          hospitalId: this.searchParam.hospitalId
        }
      }
      this.usersSocket.updateParameter(userParam)
      //更新设备数据
      let equParam = {
        socketType: "updateParameter",
        equMaintenanceTotalSearchDTO :{
          hospitalId: this.searchParam.hospitalId
        },
        equPurchaseTotalSearchDTO :{
          hospitalId: this.searchParam.hospitalId
        },
        equMedicalClassificationTotalSearchDTO :{
          hospitalId: this.searchParam.hospitalId
        },
        hospitalManageTotalSearchDTO :{
          hospitalId: this.searchParam.hospitalId
        }
      }
      this.equSocket.updateParameter(equParam)
      //更新保养数据
      console.log('更新保养数据',this.lineSearchParam)
      let maintainParam = {
        socketType: "updateParameter",
        finishSearchDto: {
          createTimeBegin: this.searchParam.startTime,
          createTimeEnd: this.searchParam.endTime,
          hospitalId:this.searchParam.hospitalId,
        },
        statisticsMaintainSearchDto: {
          searchTimeType: this.lineSearchParam.dateType,
          startTime:this.lineSearchParam.startTime,
          endTime:this.lineSearchParam.endTime,
          hospitalId: this.lineSearchParam.hospitalId
        }
      }
      this.maintainSocket.updateParameter(maintainParam)
      //更新巡检数据
      let inspectParam = {
        socketType: "updateParameter",
        finishSearchDto: {
          createTimeBegin: this.searchParam.startTime,
          createTimeEnd: this.searchParam.endTime,
          hospitalId:this.searchParam.hospitalId,
        },
        statisticsInspectSearchDto: {
          searchTimeType: this.lineSearchParam.dateType,
          startTime:this.lineSearchParam.startTime,
          endTime:this.lineSearchParam.endTime,
          hospitalId: this.lineSearchParam.hospitalId
        }
      }
      this.inspectSocket.updateParameter(inspectParam)
      //更新维修数据
      let repairParam = {
        socketType: "updateParameter",
        largeScreenSearchDto: {
          startTime: this.searchParam.startTime,
          endTime: this.searchParam.endTime,
          hospitalId:this.searchParam.hospitalId,
        },
        isHospital: this.isHospital, //是否查医院排行
        statisticsParameterDto: {
          hospitalId:this.searchParam.hospitalId,
          startTime: this.searchParam.startTime,
        endTime: this.searchParam.endTime,
        }
      }
      console.log('更新维修数据',repairParam)
      this.repairSocket.updateParameter(repairParam)
      //更新统计信息
      let statisticsParam = {
        socketType: "updateParameter",
        largeScreenSearchDto: {
          startTime: this.searchParam.startTime,
          endTime: this.searchParam.endTime,
          hospitalId:this.searchParam.hospitalId,
        },
        finishSearchDto: {
          createTimeBegin: this.searchParam.startTime,
          createTimeEnd: this.searchParam.endTime,
          hospitalId: this.searchParam.hospitalId
        },
      }
      
      this.statisticsSocket.updateParameter(statisticsParam)
    },
    //共享节点信息
    shareInformation(message,sendId){
      let info = {
        socketType: "shareInfo",
        webSocketShareDto:{
          sendId,//共享信息客户端的二级ID
          message:JSON.stringify(message)
        }
      }
      this.statisticsSocket.shareInformation(info)
    },
    //重新获取info
    refreshInfoData(){
      this.infoSocket.updateParameter()
    },
    //执行其他操作
    //查询分页巡检工单
    findEquInspectPage(){
      // this.searchParam.findEquInspectPageParam.hospitalId = this.searchParam.hospitalId
      // this.searchParam.findEquInspectPageParam.createTimeBegin = this.searchParam.startTime
      // this.searchParam.findEquInspectPageParam.createTimeEnd = this.searchParam.endTime
      let param = {
        equInspectPageDto : this.searchParam.findEquInspectPageParam
      }
      this.infoSocket.doOperation("findEquInspectPage",param)
    },
    //查询分页正在执行巡检数据
    findExecutingInspectPage(){
      // this.searchParam.findExecutingInspectPageParam.hospitalId = this.searchParam.hospitalId
      // this.searchParam.findExecutingInspectPageParam.createTimeBegin = this.searchParam.startTime
      // this.searchParam.findExecutingInspectPageParam.createTimeEnd = this.searchParam.endTime
      let param = {
        equInspectPageDto : this.searchParam.findExecutingInspectPageParam
      }
      this.infoSocket.doOperation("findExecutingInspectPage",param)
    },
    //查询分页正在巡检数据
    findInspectExecutingPage(){
      // this.searchParam.findInspectExecutingPageParam.hospitalId = this.searchParam.hospitalId
      // this.searchParam.findInspectExecutingPageParam.createTimeBegin = this.searchParam.startTime
      // this.searchParam.findInspectExecutingPageParam.createTimeEnd = this.searchParam.endTime
      let param = {
        equInspectPageDto : this.searchParam.findInspectExecutingPageParam
      }
      this.infoSocket.doOperation("findInspectExecutingPage",param)
    },
    //分页查询正在执行保养数据
    findExecutingMaintainPage(){
      // this.searchParam.findExecutingMaintainPageParam.hospitalId = this.searchParam.hospitalId
      // this.searchParam.findExecutingMaintainPageParam.createTimeBegin = this.searchParam.startTime
      // this.searchParam.findExecutingMaintainPageParam.createTimeEnd = this.searchParam.endTime
      let param = {
        maintainOrderPageDto : this.searchParam.findExecutingMaintainPageParam
      }
      this.infoSocket.doOperation("findExecutingMaintainPage",param)
    },
    //分页查询正在保养数据
    findMaintainExecutingPage(){
      // this.searchParam.findMaintainExecutingPageParam.hospitalId = this.searchParam.hospitalId
      // this.searchParam.findMaintainExecutingPageParam.createTimeBegin = this.searchParam.startTime
      // this.searchParam.findMaintainExecutingPageParam.createTimeEnd = this.searchParam.endTime
      let param = {
        maintainOrderPageDto : this.searchParam.findMaintainExecutingPageParam
      }
      this.infoSocket.doOperation("findMaintainExecutingPage",param)
    },
    //查询分页保养单
    findMaintainPage(){
      // this.searchParam.findMaintainPageParam.hospitalId = this.searchParam.hospitalId
      // this.searchParam.findMaintainPageParam.createTimeBegin = this.searchParam.startTime
      // this.searchParam.findMaintainPageParam.createTimeEnd = this.searchParam.endTime
      let param = {
        maintainOrderPageDto : this.searchParam.findMaintainPageParam
      }
      this.infoSocket.doOperation("findMaintainPage",param)
    },
    //分页查询设备
    getEquPage(){
      // this.searchParam.getEquPageParam.hospitalId = this.searchParam.hospitalId
      let param = {
        searchDTO : this.searchParam.getEquPageParam
      }
      this.infoSocket.doOperation("getEquPage",param)
    },
    //分页查询维修
    pageRepair(){
      // this.searchParam.pageRepairParam.hospitalId = this.searchParam.hospitalId
      // this.searchParam.pageRepairParam.reportStartTime = this.searchParam.startTime
      // this.searchParam.pageRepairParam.reportEndTime = this.searchParam.endTime
      
      let param = {
        repairSearchDto : this.searchParam.pageRepairParam
      }
      this.infoSocket.doOperation("pageRepair",param)
    },
    //分页查询正在维修
    pageBeingRepaired(){
      // this.searchParam.pageBeingRepairedParam.hospitalId = this.searchParam.hospitalId
      // this.searchParam.pageBeingRepairedParam.reportStartTime = this.searchParam.startTime
      // this.searchParam.pageBeingRepairedParam.reportEndTime = this.searchParam.endTime
      let param = {
        repairOrderPageDto : this.searchParam.pageBeingRepairedParam
      }
      this.infoSocket.doOperation("pageBeingRepaired",param)
    },
    // 查询科室列表
    getDepartmentList(){
      let param = {
        hospitalId : this.searchParam.hospitalId
      }
      this.infoSocket.doOperation("getDepartmentList",param)
    },
    selectEngineerRankingByPage(){
      let param = {
        largeScreenPageSearchDto:{
          page:this.searchParam.selectEngineerRankingByPage.page,
          size:this.searchParam.selectEngineerRankingByPage.size,
          hospitalId: this.searchParam.selectEngineerRankingByPage.hospitalId,
          departId:this.searchParam.selectEngineerRankingByPage.departId,
          startTime: this.searchParam.selectEngineerRankingByPage.startTime,
          endTime: this.searchParam.selectEngineerRankingByPage.endTime
        }
      }
      this.infoSocket.doOperation("selectEngineerRankingByPage",param)
    }
  }
}

export {SocketInit}



// WEBPACK FOOTER //
// ./src/utils/websocket/socketUtil.js